import React from 'react'
import {
    Button
} from 'reactstrap'

const button =(props)=> <Button {...props}/>

export default button